<div class="tp-page">
  <tp-page-header
    title="Zona de acción"
    [subtitle]="companyName ? 'Franquicia ' + companyName : 'Definí el área donde trabaja la franquicia'"
  ></tp-page-header>

  <section class="tp-card fz-card">
    <p class="fz-hint">Dibujá un círculo sobre el mapa o ajustá el existente; tocá el círculo para eliminarlo.</p>
    <div class="fz-map">
      <indu-map [drawZone]="drawZone" [zoom]="12" [source]="'franchise'" [center]="center" [clickable]="true"
        [circleCenter]="circleCenter" (setZone)="setFranchiseZone($event)" (deleteZone)="deleteFranchiseZone()"></indu-map>
    </div>
    <div class="fz-actions">
      <button mat-stroked-button type="button" (click)="onCancel()">Cancelar</button>
      <button mat-flat-button type="button" class="btn-confirm" (click)="onSubmit()">Confirmar</button>
    </div>
  </section>
</div>
